"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
export default function Procurement() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const tableData = [{
    segment: "Vendor Audits",
    region: "North America",
    revenue: 4280000
  }, {
    segment: "Supply Chain",
    region: "Europe",
    revenue: 3140000
  }, {
    segment: "Contract Compliance",
    region: "North America",
    revenue: 2890000
  }, {
    segment: "Logistics Planning",
    region: "Asia Pacific",
    revenue: 2120000
  }, {
    segment: "Risk Assessment",
    region: "Europe",
    revenue: 1870000
  }, {
    segment: "Procurement Strategy",
    region: "Latin America",
    revenue: 1340000
  }, {
    segment: "Inventory Control",
    region: "Asia Pacific",
    revenue: 980000
  }, {
    segment: "Resource Allocation",
    region: "Middle East",
    revenue: 740000
  }];
  const maxRevenue = Math.max(...tableData.map(d => d.revenue));
  const chartData = tableData.map((d, i) => ({
    label: d.segment,
    value: d.revenue,
    highlighted: i === 1,
    widthPct: d.revenue / maxRevenue * 100
  }));
  const formatCurrency = (val: number) => new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0
  }).format(val);
  return;
}